function plainText(value: string): string {
  return value
    .replace(/<[^>]+>/g, " ")
    .replace(/&copy;/gi, "©")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Combines provider attribution without silently discarding independent source credits.
 * Exact duplicates and shorter credits already contained by a longer credit are removed.
 */
export function combineAttributions(...values: Array<string | undefined>): string {
  const credits: string[] = [];
  for (const value of values) {
    if (!value) continue;
    const candidate = plainText(value);
    if (!candidate) continue;
    const normalizedCandidate = candidate.toLocaleLowerCase();
    if (credits.some((credit) => credit.toLocaleLowerCase().includes(normalizedCandidate))) continue;
    for (let index = credits.length - 1; index >= 0; index -= 1) {
      if (normalizedCandidate.includes(credits[index]!.toLocaleLowerCase())) credits.splice(index, 1);
    }
    credits.push(candidate);
  }
  return credits.join(" · ");
}
